<template>
  <img :src="value" :style="style" />
</template>

<script>
export default {
  props: {
    value: { type: String, default: '' },
    style: { type: String, default: 'max-height: 3rem' },
  },
  setup() {
    return {};
  },
};
</script>
